// 使用者站內訊息 API（使用 usersRequest，帶 Bearer Token）
import usersRequest from '../core/usersRequest';

/**
 * 取得站內訊息列表
 * @param {{ page?: number, isRead?: number }} [params]
 *   page 頁數（預設 1）；isRead 0 未讀 / 1 已讀（預設 0）
 * @returns {Promise<NotifyMessageListResponse>}
 * @see {@link ./types.js} NotifyMessageListResponse
 */
const apiGetNotifyMessageList = ({ page = 1, isRead = 0 } = {}) => usersRequest.get(`/v1/notify/message/list?page=${page}&is_read=${isRead}`);

/**
 * 標記站內訊息為已讀（/v1/notify/message/:message_id/read）
 * @param {string|number} id - 訊息 ID（route param message_id）
 * @returns {Promise<MessageResponse>}
 * @see {@link ../core/types.js} MessageResponse
 */
const apiPutNotifyMessageRead = (id) => usersRequest.put(`/v1/notify/message/${id}/read`);

/**
 * 標記站內訊息為未讀（/v1/notify/message/:message_id/unread）
 * @param {string|number} id - 訊息 ID（route param message_id）
 * @returns {Promise<MessageResponse>}
 * @see {@link ../core/types.js} MessageResponse
 */
const apiPutNotifyMessageUnread = (id) => usersRequest.put(`/v1/notify/message/${id}/unread`);

export default {
  apiGetNotifyMessageList,
  apiPutNotifyMessageRead,
  apiPutNotifyMessageUnread,
};
